import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { CalendarModule, CalendarTypeView } from 'primeng/calendar';

interface DatepickerProps extends FormlyFieldProps {
  dateFormat?: string;
  hourFormat?: string;
  showTime?: boolean;
  showIcon?: boolean;
  showButtonBar?: boolean;
  showOtherMonths?: boolean;
  selectOtherMonths?: boolean;
  selectionMode?: 'single' | 'multiple' | 'range';
  numberOfMonths?: number;
  inline?: boolean;
  readonlyInput?: boolean;
  touchUI?: boolean;
  monthNavigator?: boolean;
  yearNavigator?: boolean;
  yearRange?: string;
  view?: CalendarTypeView;
  minDate?: Date;
  maxDate?: Date;
  defaultDate?: Date;
  disabledDates?: Date[];
  onSelect?: (date: Date) => void;
}

export interface FormlyDatepickerFieldConfig
  extends FormlyFieldConfig<DatepickerProps> {
  type: 'datepicker' | Type<FormlyDatepickerTypeComponent>;
}

@Component({
  standalone: true,
  selector: 'kon-datepicker-type',
  imports: [CalendarModule, ReactiveFormsModule],
  template: ` <p-calendar
    [dateFormat]="props.dateFormat ?? 'dd.mm.yy'"
    [hourFormat]="props.hourFormat ?? '24'"
    [showTime]="props.showTime ?? false"
    [showIcon]="props.showIcon"
    [showButtonBar]="props.showButtonBar"
    [showOtherMonths]="props.showOtherMonths ?? false"
    [selectOtherMonths]="props.selectOtherMonths"
    [selectionMode]="props.selectionMode ?? 'single'"
    [numberOfMonths]="props.numberOfMonths ?? 1"
    [inline]="props.inline ?? false"
    [readonlyInput]="props.readonlyInput"
    [touchUI]="props.touchUI"
    [monthNavigator]="props.monthNavigator"
    [yearNavigator]="props.yearNavigator"
    [placeholder]="props.placeholder"
    [yearRange]="props.yearRange ?? '0-21000'"
    [formControl]="formControl"
    [showClear]="!props.required"
    [view]="props.view ?? 'date'"
    [minDate]="props.minDate"
    [maxDate]="props.maxDate"
    [disabledDates]="props.disabledDates || []"
    [defaultDate]="props.defaultDate || newDate"
    (onSelect)="props.onSelect?.($event)"
    appendTo="body"
  >
  </p-calendar>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDatepickerTypeComponent extends FieldType<
  FieldTypeConfig<DatepickerProps>
> {
  newDate = new Date();
}
